import axios from "axios";
import { apiInstance } from "../../api/api";

type UserInfoResponseType = {
  status: "OK";
  canBet: boolean;
  user: {
    fullName: string;
    username: string;
    parentUserId: string;
    userId: string;
    currency: string;
    country: string;
    balance: number;
    status: string;
    allowedGames: Array<string>;
  };
};

export type ExecutionsListResponse = {
  status: string;
  yantraExecutions: YantraExecution[];
};

export type YantraExecution = {
  id: string;
  yantraId: string;
  currency: string;
  countryCode: string;
  status: string;
  name: string;
  startDate: number;
  stopBetsDate: number;
  calculateDate: number;
  restartDate: number;
  image: string;
  price: number;
  payout: number;
  tickets: { [key: string]: number };
  resultIndex: number;
  previousExecutionId: string;
  rowPrice: number;
  rowPayout: number;
};

export type Yantra = {
  id: string;
  image: string;
  name: string;
};

export type YantraExecutionStatus = // placed in real life time order

    | "WAITING_SCHEDULE" // just created and waiting future execution
    | "RUNNING" // running, can be bought at this time
    | "CALCULATING" // sales stopped, just calculating
    | "CALCULATED" // calculated, just calculating and waiting for next restart
    | "RESTARTED" // restarted, means this execution has generated new one
    | "PAUSED"; // execution has paused (will be implemented next)

export type YantraExecutionInfo = {
  id: string;
  yantraId: string;
  currency: string;
  countryCode: string;
  status: YantraExecutionStatus;
  name: string;
  startDate: number;
  stopBetsDate: number;
  calculateDate: number;
  restartDate: number;
  image: string;
  price: number;
  payout: number;
  tickets: { [key: string]: number };
  rowTickets: { [key: string]: number };
  rowPrice: number;
  rowPayout: number;
  previousExecutionId: string;
  yantras: Yantra[];
  resultIndex: number;
  yantraRows: number;
  yantraCols: number;
};

export const fetchExecutions = async ({ sessionId }: { sessionId: string }) => {
  const response = await apiInstance.get<ExecutionsListResponse>(
    `/api/yantra/user/executions`,
    {
      headers: {
        sessionId,
      },
    }
  );
  return response.data;
};

export const fetchExecution = async ({
  sessionId,
  executionId,
}: {
  sessionId: string;
  executionId: string;
}) => {
  const response = await apiInstance.get<{
    yantraExecution: YantraExecutionInfo;
  }>(`/api/yantra/user/execution/${executionId}`, {
    headers: {
      sessionId,
    },
  });
  return response.data;
};

export const buyExecution = async (
  executionId: string,
  sessionId: string,
  tickets: {
    images: Record<string, number> | {};
    rows: Record<string, number> | {};
  }
) => {
  const response = await apiInstance.post(
    `/api/yantra/user/execution/${executionId}/buy`,
    tickets,
    {
      headers: {
        sessionId,
      },
    }
  );
  return response.data;
};

export const fetchPlayerHistory = async (sessionId: string) => {
  const response = await apiInstance.get(`/api/yantra/user/history`, {
    headers: {
      sessionId,
    },
  });
  return response.data;
};

export const fetchPlayerInfo = async (sessionId: string) => {
  const response = await axios.get<UserInfoResponseType>(
    `${import.meta.env.VITE_PYRAMID_URL}/pyramid/user/info`,
    {
      headers: {
        sessionId,
      },
    }
  );
  return response.data;
};
